import { defineComponent as _defineComponent } from 'vue'

export enum OzBoxColors {
  /** Base page background color. Light mode: white. Dark mode: black. */
  Primary = 'Primary',

  /** Used for popovers. Light mode: common-ui-l86. Dark-mode: common-ui-l86 */
  PrimaryBlur = 'PrimaryBlur',

  /** Used for cross library selection menu & layout picker. Light mode: light-ui-100. Dark-mode: dark-ui-100 */
  PrimaryLight = 'PrimaryLight',

  /** Used for section boxes over Primary background. Light mode: light grey. Dark mode: dark grey */
  Secondary = 'Secondary',

  /** Color of active/selected items. Light mode: grape. Dark mode: canary */
  Selection = 'Selection',

  /** Color of a highlighted section. Light mode: light canary. Dark mode: dark-ui */
  Highlight = 'Highlight',

  /** Light mode: tangerine. Dark mode: dark-ui. */
  Destructive = 'Destructive',

  /** Light mode: padlet pink. Dark mode: dark-ui. */
  Pink = 'Pink',

  /** Color of a highlighted section. Light mode: park. Dark mode: dark-ui */
  Green = 'Green',

  /** Color of a highlighted section. Light mode: tangerine. Dark mode: dark-ui. */
  Tangerine = 'Tangerine',

  /** Color of a highlighted section. Light mode: grape. Dark mode: dark-ui. */
  Grape = 'Grape',

  /** Color of a disabled section in the delete account page. Light mode: grey-0. Dark mode: grey-850. */
  Grey = 'Grey',

  /** Light mode: oceanic. Dark mode: dark-ui. */
  Oceanic = 'Oceanic',

  /** Light mode: scarlet-0. Dark mode: dark-ui-200. */
  Scarlet = 'Scarlet',

  /** Color of a post attachment/sub-element for a post with default color. Light mode: light-ui-200. Dark mode: dark-ui-200. */
  PostDefault = 'PostDefault',

  /** Color of a post attachment/sub-element for a red post. Light mode: scarlet-200. Dark mode: scarlet-800. */
  PostRed = 'PostRed',

  /** Color of a post attachment/sub-element for an orange post. Light mode: canary-200. Dark mode: tangerine-800. */
  PostOrange = 'PostOrange',

  /** Color of a post attachment/sub-element for a green post. Light mode: park-200. Dark mode: park-800. */
  PostGreen = 'PostGreen',

  /** Color of a post attachment/sub-element for a blue post. Light mode: oceanic-200. Dark mode: oceanic-800. */
  PostBlue = 'PostBlue',

  /** Color of a post attachment/sub-element for a purple post. Light mode: grape-200. Dark mode: grape-800. */
  PostPurple = 'PostPurple',

  /** Color of done tasks. */
  TaskDone = 'TaskDone',

  /** No color. OzBox will just provide the shape. */
  None = 'None',
}

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBox',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    color: { default: null },
    radius: { default: 20 }
  },
  setup(__props: any) {



return { __sfc: true,OzBoxColors }
}

})